import { Box } from '@mui/material';
import PageHeader from 'components/new_components/PageHeader';
import React, { useEffect, useState } from 'react';
// import { useDispatch } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import getRoutes from 'routes/businessProfileRoutes';

export default function BusinessProfileLayout() {
    const [routes, setRoutes] = useState(undefined);
    // generate the routes
    const generateRoutes = (routes) => {
        const routesList = routes?.map((prop, key) => {
            return <Route exact path={prop.layout + prop.path} component={prop.component} key={key} />;
        });
        if (routesList) {
            routesList.push(<Redirect to="/business-profile/login" key="redirect" />);
        }
        return routesList;
    };

    useEffect(() => {
        const manifestLink = document.createElement('link');
        manifestLink.rel = 'manifest';
        manifestLink.href = '/business-profile/manifest.json';

        // removes global manifest link
        const existing = document.querySelector('link[rel="manifest"]');
        if (existing) {
            existing.parentNode.removeChild(existing);
        }

        document.head.appendChild(manifestLink);

        return () => {
            // cleanup when leaving the route
            if (manifestLink && manifestLink.parentNode) {
                manifestLink.parentNode.removeChild(manifestLink);
            }
        };
    }, []);

    useEffect(() => {
        const routes = getRoutes();
        setRoutes(routes);
    }, [localStorage.getItem('i18nextLng')]);

    return (
        <>
            <PageHeader browserTitle="Business Profile | Smartcomply" />
            <Box
                sx={{
                    height: '100%',
                    p: 0,
                    backgroundColor: '#eef2f6',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <Box
                    sx={{
                        height: '100%',
                        minHeight: '100dvh',
                        p: 0,
                        backgroundColor: '#eef2f6',
                        width: '100%',
                        maxWidth: {
                            lg: '520px',
                        },
                    }}
                >
                    <Switch>{generateRoutes(routes)}</Switch>
                </Box>
            </Box>
        </>
    );
}
